import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome'
import * as styles from './_SuccessCheckMessage.scss'
import withStyles from 'isomorphic-style-loader/withStyles'
import React from 'react';

const SuccessCheckMessage = function ({ message, children, removeMargin }) {
  return <span className={styles['success-message'] + (removeMargin ? ' ' + styles['no-margin'] : '')}>
    <div>
      <FontAwesome className={styles['success-check']} name='check' />
      &nbsp;
      {message}
      &nbsp;
      {children}
    </div>
  </span>
}

SuccessCheckMessage.propTypes = {
  message: PropTypes.string.isRequired,
  children: PropTypes.object,
  removeMargin: PropTypes.bool
}

export default (SuccessCheckMessage)
